Number.prototype.addVat = function (percent) {
    return this * ((percent / 100) + 1);
};
Number.prototype.toFixedNumber = function (precision) {
    let rounder = Math.pow(10, precision);
    return Math.round(this * rounder) / rounder;
};
Number.prototype.toPrettyNumber = function (precision, locale) {
    return this.toLocaleString(locale ? locale : 'sv-SE', { useGrouping: true, maximumFractionDigits: precision }).replace(",", ".");
};
Number.prototype.countDecimals = function () {
    if (Math.floor(this.valueOf()) === this.valueOf())
        return 0;
    var str = this.toString();
    if (str.indexOf(".") !== -1 && str.indexOf("-") !== -1) {
        return str.split("-")[1] || 0;
    }
    else if (str.indexOf(".") !== -1) {
        return str.split(".")[1].length || 0;
    }
    else if (str.indexOf(",") !== -1) {
        return str.split(",")[1].length || 0;
    }
    return str.split("-")[1] || 0;
};
